/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import App from './app';
import serverData from './utils/server-data';
import { ContextProvider as GriffinContextProvider } from '@paypalcorp/worldready-react';
import { Provider } from 'react-redux';
import createStore from './configureStore';
import { initAnalytics, setupAnalytics } from './utils/init-analytics';
import fraudNet from './utils/fraudNetUtil';
import 'core-js';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

if (window) {
    initAnalytics(window.PAYPAL, setupAnalytics, 0);
}

fraudNet.trigger(serverData.fraudNet);

const { store, history } = createStore();
let root = document.getElementById('root');

if (!root) {
    root = document.createElement('div');
    document.body.appendChild(root);
}

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistStore(store)}>
            <GriffinContextProvider locale={serverData.locality.locale}>
                <BrowserRouter basename={serverData.requestURI}>
                    <Routes>
                        <Route path="*" element={<App />} />
                    </Routes>
                </BrowserRouter>
            </GriffinContextProvider>
        </PersistGate>
    </Provider>,
    root
);
